export default __webpack_public_path__ + "static/media/electric-vehicle.d4668513.svg";